__turbopack_context__.v({
  "activeTab": "authDialog-module__Amh84a__activeTab",
  "body": "authDialog-module__Amh84a__body",
  "checkLine": "authDialog-module__Amh84a__checkLine",
  "close": "authDialog-module__Amh84a__close",
  "codeRow": "authDialog-module__Amh84a__codeRow",
  "copy": "authDialog-module__Amh84a__copy",
  "dialog": "authDialog-module__Amh84a__dialog",
  "embedded": "authDialog-module__Amh84a__embedded",
  "form": "authDialog-module__Amh84a__form",
  "message": "authDialog-module__Amh84a__message",
  "overlay": "authDialog-module__Amh84a__overlay",
  "submit": "authDialog-module__Amh84a__submit",
  "tab": "authDialog-module__Amh84a__tab",
  "titleBar": "authDialog-module__Amh84a__titleBar",
});
